@if (isLoading) {
  <app-chart-loading></app-chart-loading>
} @else {
  <div [id]="config.chartId" class="two-linked-pie-canvas"></div>
}
